/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_TitleInputs */

const en_landing_title = /** @type {(inputs: Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are we building today?`)
};

const id_landing_title = /** @type {(inputs: Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mau mulai dari mana?`)
};

/**
* | output |
* | --- |
* | "What are we building today?" |
*
* @param {Landing_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_title = /** @type {((inputs?: Landing_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_title(inputs)
	return en_landing_title(inputs)
});